export enum BrandColor {
  Red =  '#AF1E2C',
  DarkRed = '#8B0E04',

  Gray = '#58595B',
  Green = '#006800',
  Yellow = '#FFC82C',
  RedAlert = '#B50000',
}
